// extracted by mini-css-extract-plugin
module.exports = {"root":"IdOrigin_root__29qGV","user":"IdOrigin_user__3X-Yd","system":"IdOrigin_system__3-P9c"};